// Rank & experience system — pure utility, no framework deps

export const RANKS = [
    { minLevel: 1,   maxLevel: 10,  name: 'Recruit',          bonus: null },
    { minLevel: 11,  maxLevel: 50,  name: 'Sweep Cadet',      bonus: null },
    { minLevel: 51,  maxLevel: 100, name: 'Field Scout',      bonus: null },
    { minLevel: 101, maxLevel: 170, name: 'Mine Surveyor',    bonus: null },
    { minLevel: 171, maxLevel: 300, name: 'Blast Sergeant',   bonus: null },
    { minLevel: 301, maxLevel: 500, name: 'Defusal Expert',   bonus: null },
    { minLevel: 501, maxLevel: 750, name: 'Ordnance Captain', bonus: null },
    { minLevel: 751, maxLevel: 950, name: 'Bombproof Major',  bonus: null },
    { minLevel: 951, maxLevel: 999, name: 'Mines Master',     bonus: null },
];

/**
 * Get rank info for a given number of cleared levels.
 * @param {number} cleared — total levels cleared
 * @returns {{ rank: object, rankIndex: number, progress: number, levelInRank: number, rankSize: number }}
 */
export function getRankForLevel( cleared )
{
    if ( cleared < 1 )
    {
        return {
            rank: RANKS[ 0 ],
            rankIndex: 0,
            progress: 0,
            levelInRank: 0,
            rankSize: RANKS[ 0 ].maxLevel - RANKS[ 0 ].minLevel + 1,
        };
    }

    for ( let i = RANKS.length - 1; i >= 0; i-- )
    {
        if ( cleared >= RANKS[ i ].minLevel )
        {
            const rank = RANKS[ i ];
            const rankSize = rank.maxLevel - rank.minLevel + 1;
            const levelInRank = cleared - rank.minLevel + 1;
            const progress = Math.min( 1, Math.max( 0, levelInRank / rankSize ) );

            // Completed all levels in this rank — promote to next rank
            if ( progress >= 1 && i < RANKS.length - 1 )
            {
                const next = RANKS[ i + 1 ];
                const nextSize = next.maxLevel - next.minLevel + 1;
                return { rank: next, rankIndex: i + 1, progress: 0, levelInRank: 0, rankSize: nextSize };
            }

            return { rank, rankIndex: i, progress, levelInRank, rankSize };
        }
    }

    // Fallback (shouldn't happen)
    return {
        rank: RANKS[ 0 ],
        rankIndex: 0,
        progress: 0,
        levelInRank: 0,
        rankSize: RANKS[ 0 ].maxLevel - RANKS[ 0 ].minLevel + 1,
    };
}
